export default __webpack_public_path__ + "static/media/toeflinternationalacademy.712cd49f.png";